<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="银行名称" prop="name" >
        <a-input v-model="form.name" placeholder="请输入银行名称" />
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark" >
        <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <a-form-model-item label="排序" prop="sort" >
        <a-button-group>
          <a-button @click="decline">
            <template><a-icon type="minus" /></template>
          </a-button>
          <a-input @input="validateNumber" type="number" :max-length="5" style="width: 120px" v-model="form.sort"/>
          <a-button @click="increase">
            <template><a-icon type="plus" /></template>
          </a-button>
        </a-button-group>
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getBank, addBank, updateBank } from '@/api/user/bank'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        name: null,

        sort: null,

        cateName: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        name: [
          { required: true, message: '银行名称不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    validateNumber(event) {
      // 允许输入数字、小数点、负号
      // 同时设置了type="number"，所以还能防止非数字的输入
      event.target.value = event.target.value.replace(/[^0-9.]+/g, '')
      // 如果有小数点，只保留第一个
      const decimalIndex = event.target.value.indexOf('.')
      if (decimalIndex !== -1) {
        event.target.value = event.target.value.substr(0, decimalIndex) + '.' + event.target.value.substr(decimalIndex).replace(/\./g, '')
      }
      // 如果第一个字符是负号，保证只有当输入有数字时才允许负号
      if (event.target.value[0] === '-' && event.target.value.length > 1) {
        event.target.value = '-' + event.target.value.substr(1).replace(/[^0-9.]+/g, '')
      }
      // 更新数据
      this.form.sort = parseFloat(event.target.value)
    },
    decline() {
      const that = this
      that.form.sort = that.form.sort - 1
      if (that.form.sort < 0) {
        that.form.sort = 0
      }
    },
    increase() {
      const that = this
      that.form.sort = that.form.sort + 1
    },
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        name: null,
        sort: null,
        cateName: null,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd () {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getBank({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateBank(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addBank(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
